<template>
  <p class="text-12 mb-0">
    Ved å huke av bruktbilgaranti godkjenner du <a
      href="/okonomi/bruktbilgaranti?seller=true"
      target="_blank"
    >vilkårene</a> for bruk av tjenesten. Vi sender bilens registreringsnummer sammen med ditt navn og e-postadresse til If Skadeforsikring.
  </p>
</template>
